export const Status = {
  FAILED: 'failed',
  PROCESSING: 'processing',
  READY: ''
};

export const DataKeys = {
  People: 'people'
};